<template>
  <div class="newsInfo-page">
    <Header ref="Header"
      @onChangLogin="onChangLogin"
      :isLogin="loginShow"
      :setShow="['news']"
    />
    <NavBar ref="NavBar" :tab="5" @onChangLogin="onChangLogin" :isLogin="loginShow" />
    <div class="pageContent flex flex-pack-justify">
      <div class="news">
        <div class="live-loading" v-if="isloadingShow" style="padding: 10% 0 20% 0 ;">
          <van-loading vertical><span class="loadtext">{{ langConfig.txtLang[langConfig.curLang]['LOADING'] }}</span></van-loading>
        </div>
        <!-- 新闻类别 -->
        <div class="newsType" :class="isCeiling?'ceiling_on':''" v-if="newsCategoryList.length > 0">
          <ul class="flex" @mousedown="mousedown" @mouseup="mouseup" @mousemove="mousemove" ref="newsType">
            <li @click="changeType(0)" >{{ langConfig.news[langConfig.curLang]['ALL'] }}</li>
            <li @click="changeType(item.id)" v-for="(item,index) in newsCategoryList" :key="index">{{item.name}}</li>
          </ul>
        </div>
        <!-- 面包屑 -->
        <div class="crumb flex flex-align-center" v-if="newsInfo.hasOwnProperty('category')">
          <router-link :to="{path:'/news/0'}">{{ langConfig.news[langConfig.curLang]['NEWS'] }}</router-link>
          <span> > </span>
          <router-link :to="{path:'/news/' + newsInfo.category.id}">{{ newsInfo.category.name }}</router-link>
          <span> > </span>
          <div class="main-text">{{ newsInfo.title }}</div>
        </div>
        <!-- 内容 -->
        <div class="infoBox" v-if="Object.keys(this.newsInfo).length != 0">
          <div class="account flex flex-align-center" v-if="newsInfo.hasOwnProperty('author')">
            <div class="account-img" v-if="newsInfo.author.avatar"><img :src="newsInfo.author.avatar"></div>
            <div class="account-name">{{ newsInfo.author.name }}</div>
          </div>
          <h1 class="info-title">{{ newsInfo.title }}</h1>
          <div class="info-source">
            {{ langConfig.news[langConfig.curLang]['POSTED'] }} {{ weekArr[new Date(newsInfo.createTime).getDay()] }}, 
            {{ datetimeStr(newsInfo.createTime * 1000,0) }} 
            <span v-if="newsInfo.source && newsInfo.source != 'undefined'">
              {{ langConfig.news[langConfig.curLang]['BY'] }} 
              <span :class="isEffectiveWeb == true ? 'isEffectiveWeb' : ''" @click="toSourceWeb(newsInfo.source)">{{ newsInfo.source }}</span>
            </span> 
          </div>
          <div class="info-content" v-html="newsInfo.content"></div>
        </div>
      </div>
      <div class="page-right">
        <template v-if="ListAd.length>0">
          <template v-for="(item, index) in ListAd">
            <div class="ad-box" :class="item.siteId == 602 ? 'ad-sticky' : ''" :key="index">
              <router-link :to="'/gdt?gdtUrl=' + item.url" target="_blank" @click.native="adHit(item.id)"><img :src="item.img" /></router-link>
            </div>
          </template>
        </template>
      </div>
    </div>
    <Footer />
  </div>
</template>
<script>
import Header from "@/components/header.vue";
import NavBar from "@/components/navbar.vue";
import Footer from "@/components/footer.vue";

import { mapState, mapMutations, mapActions } from 'vuex';

import { getNewsCategory, getNewsDetail, getNewsInfoHits, getListAd, getAdHits } from '@/api/api';

export default {
  name: "newsInfo",
  components: {
    Header,
    NavBar,
    Footer,
  },

  asyncData ( { store, route } ) {
    let param = {
      newsId: route.params.id,
      userToken: '',
    }
    // if(typeof window!='undefined'){
    //   let _userInfo = this.common.getCookie('userInfo');
    //   if(typeof(_userInfo) != 'undefined' && _userInfo != null){
    //     _userInfo = JSON.parse(_userInfo);
    //     param.userToken = _userInfo.token;
    //   }
    // }
    return  store.dispatch('newsInfo/getNewsDetailData', param)
  },

  data() {
    return {
      loginShow: false
      ,isloadingShow: true
      ,newsCategoryList: []
      // ,newsId: 1367
      ,newsId: this.$route.params.id
      ,newsInfo: {
        
      }
      ,weekArr: this.langConfig.txtLang[this.langConfig.curLang]['DAY_WEEK']
      ,ListAd: []
      ,isEffectiveWeb: false
      ,isDown: false // 是否按下鼠标
      ,startX: 0 // 鼠标起始位置
      ,typeScrollLeft: 0 // 滚动条位置
      ,isCeiling: false  //是否吸顶
    }
  },

  computed: {
    ...mapState('newsInfo',['getNewsInfo']),
  },

  methods:{
    ...mapMutations('newsInfo',['setNewsInfo']),
    // loading
    logdingFlag(){
      if(typeof(window) != 'undefined' && Object.keys(this.newsInfo).length == 0){
        return true;
      }

      return false;
    },

    // 点击量
    async getNewsInfoHitsData(){
      await getNewsInfoHits({newsId: this.newsId}).then((res) => {
        console.log(res,'res')
      }).catch((res) => {
        console.error(res)
      })
    },
    

    //数据读取-新闻-分类
    async getNewsCategoryData(){
      let param = {
        userToken: '',
      }
      if(typeof window!='undefined'){
        let _userInfo = this.common.getCookie('userInfo');
        if(typeof(_userInfo) != 'undefined' && _userInfo != null){
          _userInfo = JSON.parse(_userInfo);
          param.userToken = _userInfo.token;
        }
      }

      await getNewsCategory(param).then((res) => {
        this.newsCategoryList = res.data.categoryList
        this.isloadingShow = false
      }).catch((res) => {
        console.error(res)
      })
    },

    //数据读取-新闻-详细
    async getNewsDetailData(){
      let param = {
        newsId: this.newsId,
        userToken: '',
      }

      if(typeof window!='undefined'){
        let _userInfo = this.common.getCookie('userInfo');
        if(typeof(_userInfo) != 'undefined' && _userInfo != null){
          _userInfo = JSON.parse(_userInfo);
          param.userToken = _userInfo.token;
        }
      }

      await getNewsDetail(param).then((res) => {
        this.newsInfo = res.data
        console.log(this.newsInfo)
        this.setNewsInfo(res.data)

        let url = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/[\]@!\$&'\*\+,;=.]+$/;
        if (!url.test(res.data.source)) {
          this.isEffectiveWeb = false
        } else {
          this.isEffectiveWeb = true
        }
        this.isloadingShow = false
        
      }).catch((res) => {
        console.error(res)
      })

      await this.setMeta();
    },
    // 跳转来源网址 
    toSourceWeb(web){
      if(this.getNewsInfo.isEffectiveWeb){
        if(web.indexOf('http') != -1){
          window.open(web)
        }else{
          window.open('//' + web)
        }
        
      }
    },
    // 选择类别
    changeType(id){
      this.$router.push(`/news/${id}`);
    },
    //时间转换
    datetimeStr(str, type){
      var date = new Date(parseInt(str));
        var YYYY = date.getFullYear();
        var year = date.getYear()
        var year = year < 2000 ? year + 1900 : year
        var YY = year.toString().substr(2, 2);
        var MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        var dd = date.getDate();
        dd = dd < 10 ? "0" + dd : dd;
        var Bd = date.getDate();
        Bd = Bd *1;
        var HH = date.getHours();
        HH = HH < 10 ? "0" + HH : HH;
        var HD = date.getHours();
        HD = HD*1;
        var mm = date.getMinutes();
        mm = mm < 10 ? "0" + mm : mm;
        var ss = date.getSeconds();
        ss = ss < 10 ? "0" + ss : ss;

        var formal = [
        "dd/MM/YYYY",
        ];

        if(this.langConfig.curLang == 'kr'){
          formal = ["YYYY-MM-dd"];
        }

        return formal[type]
        .replace("YYYY", YYYY)
        .replace("YY", YY)
        .replace("MM", MM)
        .replace("dd", dd)
        .replace("HH", HH)
        .replace("mm", mm)
        .replace("ss", ss)
        .replace("Bd", Bd)
        .replace("HD", HD);
    },

    // 获取广告
    async getListAdData(){
      let param = {
        pageId: 6,
        userToken: '',
      }

      let _userInfo = this.common.getCookie('userInfo');
				
      if(typeof(_userInfo) != 'undefined' && _userInfo != null){
        _userInfo = JSON.parse(_userInfo);
        param.userToken = _userInfo.token;
      }

      await getListAd(param).then((res) => {
        console.log(res.data)
        this.ListAd = res.data.webAds
      })
    },

    // 点击广告
    adHit(id){
      let _id = id;
      let _param = {
        id: _id
      }
      getAdHits(_param);
    },

    /* 分类拖动-start */
    mousedown(event){
      this.isDown = true;
      this.startX = event.pageX - this.$refs.newsType.offsetLeft
      this.typeScrollLeft = this.$refs.newsType.scrollLeft
    },
    mouseup(event){
      this.isDown = false
    },
    mousemove(event){
      if (!this.isDown) return
      event.preventDefault();
      const x = event.pageX - this.$refs.newsType.offsetLeft;
      const walk = (x - this.startX) * 2; // 滑动距离
      this.$refs.newsType.scrollLeft = this.typeScrollLeft - walk;
    },
    /* 分类拖动-end */

    onChangLogin(_val) {
      console.log(_val)
      if (_val.loginShow || _val) {
        this.loginShow = true;
      } else {
        this.loginShow = false;
      }
    },

    handleScroll() {
      if(typeof window!='undefined'){
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        let Header= (this.$refs.Header?this.$refs.Header.$el.clientHeight*1:null);
        let NavBar= (this.$refs.NavBar?this.$refs.NavBar.$el.clientHeight*1:null);
        if(!Header){
          return;
        }
        
        let dif_H= scrollTop-Header-NavBar;
        this.isCeiling=(dif_H>0?true:false);
      }
    },

    setMeta(){
      if(Object.keys(this.newsInfo).length > 0){
        let title = this.newsInfo.title + ' | ' + this.langConfig.txtLang[this.langConfig.curLang]['TITLE'];
        document.title = title;
        document.querySelector('meta[property="og:title"]').setAttribute('content', title);
        document.querySelector('meta[property="og:image"]').setAttribute('content', this.newsInfo.thumbnail);
      }
    }
  },
  mounted(){
    // 监听body滚动事件
    if(typeof window!='undefined'){
      window.addEventListener('scroll', this.handleScroll);
    }
  },
  beforeDestroy() {
    // 在组件销毁前移除滚动事件监听器
    if(typeof window!='undefined'){
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
  created(){
    // this.a()
    if(typeof(window) == 'undefined'){
      if(typeof(this.$ssrContext) == 'undefined'){
        this.$ssrContext = {}
      }
      this.$ssrContext.title = this.getNewsInfo.title;
      console.log(this.getNewsInfo.keyword || '','ssrContext')
      this.$ssrContext.keywords = this.getNewsInfo.keyword || '';
      this.$ssrContext.description = this.getNewsInfo.description;
    }

    if(typeof(window) != 'undefined'){
      this.$options.title = this.getNewsInfo.title;
      console.log(this.getNewsInfo.keyword || '','options')
      this.$options.keywords = this.getNewsInfo.keyword || '';
      this.$options.description = this.getNewsInfo.description;

      this.getListAdData()
      
      this.handleScroll();
    }
    this.getNewsDetailData()
    this.getNewsCategoryData();
    this.getNewsInfoHitsData()
  },
  watch: {
    getNewsInfo: {
      deep: true,
      handler: function () {
        console.log(this.getNewsInfo,'getNewsInfo')
      },
    },
  }
}
</script>
<style lang="less">
.newsInfo-page{
  .pageContent{
    max-width: 1200px;
    margin: 0 auto;
    min-height: calc(100vh - 518px);
    .news{
      width: 976px;
      padding: 16px 8px 0 8px;
      box-sizing: border-box;
      background: @color_FFF;
      .newsType{
        padding-bottom: 16px;
        margin-bottom: 16px;
        border-bottom: 1px solid @color_F0F0F0;
        ul{
          overflow-x: auto;
          white-space: nowrap;
          user-select: none;
          li{
            border-radius: 4px;
            border: 1px solid @color_BFBFBF;
            padding: 0 16px;
            margin-right: 8px;
            font-family: @font_family_SF_Pro_Display;
            font-size: 14px;
            line-height: 22px;
            cursor: pointer;
          }
          li.active{
            background: @color_FF6915;
            border: 1px solid @color_FF6915;
            color: @color_FFF;
          }
          &::-webkit-scrollbar {
            width: 0rem; display: none!important;
          }
        }
      }
      .crumb{
        font-size: 14px;
        font-family: @font_family_SF_Pro_Display;
        border-bottom: 1px solid @color_F0F0F0;
        padding-bottom: 16px;
        padding-left: 8px;
        margin-bottom: 16px;
        a{
          color: @color_8C8C8C;
          cursor: pointer;
          flex:none
        }
        span{
          display: inline-block;
          color: @color_8C8C8C;
          padding: 0 8px;
        }
        .main-text{
          color: @color_434343;
          cursor: auto;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .infoBox{
        padding: 0 16px;
        .account{
          margin-bottom: 16px;
          .account-img{
            width: 24px;
            height: 24px;
            font-size: 0;
            margin-right: 8px;
            img{
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
          .account-name{
            font-size: 14px;
            font-family: @font_family_SF_Pro_Display;
            color: @color_000;
          }
        }
        .info-title{
          font-size: 36px;
          line-height: 48px;
          font-weight: bold;
          font-family: @font_family_SF_Pro_Display;
          color: @color_000;
          margin-bottom: 8px;
        }
        .info-source{
          font-size: 14px;
          font-family: @font_family_SF_Pro_Display;
          color: @color_8C8C8C;
          margin-bottom: 24px;
          .isEffectiveWeb{
            &:hover{
              text-decoration: underline;
              cursor: pointer;
            }
          }
          
        }
        .info-content{
          padding: 0 24px 48px 24px;
          line-height: 1.5;
          font-size: 14px;
          p{
            margin: 10px 0;
          }
          img{
            margin: 0 auto;
          }
        }
      }
      
    }
    .page-right{
      width:216px;
      padding-top: 16px;
      .ad-box{
        margin-bottom: 2px;
      }
    }
  }
}

@media screen and (min-width: 976px) and (max-width: 1026px){
  .newsInfo-page{
    .pageContent{
      .news{
        margin: 0 auto;
      }
    }
  }
}
@media screen and (max-width: 767px) {
  .newsInfo-page{
    .pageContent{
      width: 100%;
      min-height: 90vh;
      .news{
        padding: .08rem 0 0 0;
        width: 100%;
        .ceiling_on{
          padding-top: .08rem;
          position: fixed;
          top: 0;
          left: 0;
          z-index: 10;
          background: @color_FFF;
          width: 100%;
        }
        .newsType{
          margin-left: 0;
          margin-right: 0;
          padding-left: .12rem;
          padding-right: .12rem;
          width: 100%;
          border-bottom: none;
          padding-bottom: .08rem;
          margin-bottom: .08rem;
          ul{
            padding-bottom: 0;
            overflow-x: scroll;
            white-space: nowrap;
            li{ 
              border-radius: .04rem;
              border: .005rem solid @color_BFBFBF;
              padding: 0 .16rem;
              margin-right: .1rem;
              font-size: .14rem;
              line-height: .24rem;
            }
            li.active{
              border: .01rem solid @color_FF6915;
            }
          }
        }
        .newsType ul::-webkit-scrollbar {
          display: none;
        }
        .crumb{
          font-size: .12rem;
          border-bottom: none;
          padding: 0 .2rem;
          margin-bottom: 0;
          padding-bottom: 0;
          span{
            display: inline-block;
            color: @color_8C8C8C;
            padding: 0 .08rem;
          }
        }
        .infoBox{
          padding: .12rem .2rem .41rem .2rem;
          width: calc(100vw - 0.1rem);
          .account{
            margin-bottom: .12rem;
            .account-img{
              width: .16rem;
              height: .16rem;
              font-size: 0;
              margin-right: .04rem;
            }
            .account-name{
              font-size: .12rem;
            }
          }
          
          .info-title{
            font-size: .2rem;
            margin-bottom: .08rem;
            line-height: normal;
          }
          .info-source{
            font-size: .12rem;
            margin-bottom: .12rem;
          }
          .info-content{
            font-size: .14rem;
            padding: 0;
            line-height: 1.5;
            p{
              margin: .1rem 0;
            }
            img{
              max-width: 100% !important;
              height: auto !important;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// ./src/views/news/info.vue